/* eslint-disable simple-import-sort/imports */
import Lenis from '@studio-freight/lenis';
import FloatingAppointmentButton from 'components/FloatingAppointmentButton';
import Page from 'components/Page';
import React, { useEffect, useRef } from 'react';
import { Helmet } from 'react-helmet-async';
import ContactsUs from './Sections/ContactsUs/index.jsx';
import Faq from './Sections/Faq';
import { dataHero } from './Sections/Hero/data-hero.jsx';
import Hero from './Sections/Hero/index.jsx';
import InfoFaqs from './Sections/InfoFaqs';
import LogoCarouselSection from './Sections/LogoCarousel';
import Video from './Sections/Video';

const HomePage = () => {
  const heroRef = useRef(null);
  const contactFormRef = useRef(null);

  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.6,
    });

    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }

    requestAnimationFrame(raf);
  }, []);

  return (
    <Page>
      <Helmet>
        <title>Foxi abrechnung</title>
        <meta name="description" content="Endlich automatisierte Abrechnung!" />
      </Helmet>
      <div ref={heroRef}>
        <Hero />
      </div>
      <LogoCarouselSection />
      <Video />
      <InfoFaqs />
      <Faq />
      <div ref={contactFormRef}>
        <ContactsUs />
      </div>
      <FloatingAppointmentButton
        heroRef={heroRef}
        contactFormRef={contactFormRef}
        href={dataHero.button.href}
        title={dataHero.button.title}
      />
    </Page>
  );
};

export default HomePage;
